import {Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {JsonEditor, NotificationManager} from "../../../../../soajs/urac/components";
import {MultitenantService} from "../../../../../services";
import deepSet from "../../../../../soajs/libs/deepSetLib";

const multitenantService = MultitenantService.getService();
const initFields = {
	"name": "",
	"description": "",
	"type": "product",
	"tag": "",
	"profile": {},
	"mainTenant": null,
	"mainTenantName": ""
};

export default function AddTenantModal({modalOpt, setModalOpt, handleAction}) {
	const {t} = useTranslation(["common", "soajs"]);
	const handleClose = () => setModalOpt({"show": false, item: null});
	
	const [fields, setFields] = useState(initFields);
	
	function validateForm() {
		let valid = true;
		if (fields.type === "client" && !fields.mainTenant) {
			valid = false;
		}
		return (
			fields.name.length > 0 &&
			fields.description.length > 0 &&
			valid
		);
	}
	
	function JsonEditor_onChange(json) {
		fields.profile = json;
	}
	
	function handleFieldChange(event) {
		let value = event.target.value;
		if (event.target.hasOwnProperty("checked")) {
			value = event.target.checked;
		}
		let obj = fields;
		deepSet(obj, event.target.id, value);
		setFields({...obj});
	}
	
	async function handleSubmit() {
		try {
			let data = {};
			if (fields.type === "product") {
				data = {
					"name": fields.name,
					"description": fields.description,
					"type": "product",
					"tag": fields.tag,
					"profile": fields.profile
				}
			}
			if (fields.type === "client") {
				data = {
					"name": fields.name,
					"description": fields.description,
					"type": "product",
					"tag": fields.tag,
					"profile": fields.profile,
					"mainTenant": fields.mainTenant
				}
			}
			await multitenantService.addTenant(data);
			NotificationManager.success(t("soajs:messages.tenantAdd"));
			handleAction();
			handleClose();
		} catch (e) {
			NotificationManager.error(e.message);
		}
	}
	
	useEffect(() => {
		let isSubscribed = true;
		
		if (isSubscribed && modalOpt && modalOpt.item) {
			if (modalOpt.item.type === "client") {
				if (!modalOpt.item.mainTenant) {
					NotificationManager.error("You can only add a sub tenant under a main tenant.");
				}
			}
			
			setFields(Object.assign({}, initFields, modalOpt.item));
		}
		
		return () => (isSubscribed = false);
	}, [modalOpt]);
	
	return (
		<Modal show={modalOpt.show} onHide={handleClose} animation={false} size="lg">
			<Modal.Header closeButton>
				<Modal.Title>{t("soajs:titles.tenantAdd_" + fields.type)}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					{fields.type === "client" &&
					<Form.Group>
						<Form.Label>{t("soajs:fields.MainTenant")}</Form.Label>
						<Form.Control
							id="mainTenantName"
							size="sm"
							value={fields.mainTenantName}
							disabled
						/>
					</Form.Group>}
					<Form.Group>
						<Form.Label>{t("soajs:fields.Name")}</Form.Label>
						<Form.Control
							id="name"
							size="sm"
							value={fields.name}
							onChange={handleFieldChange}
						/>
					</Form.Group>
					<Form.Group>
						<Form.Label>{t("soajs:fields.Description")}</Form.Label>
						<Form.Control
							id="description"
							size="sm"
							as="textarea"
							rows={3}
							value={fields.description}
							onChange={handleFieldChange}
						/>
					</Form.Group>
					<Form.Group>
						<Form.Label>{t("soajs:fields.Tag")}</Form.Label>
						<Form.Control
							id="tag"
							size="sm"
							value={fields.tag}
							onChange={handleFieldChange}
						/>
					</Form.Group>
					<Form.Group>
						<Form.Label>{t("soajs:fields.Profile")}</Form.Label>
						<JsonEditor
							mode={"code"}
							json={fields.profile || {}}
							onChange={JsonEditor_onChange}
						/>
					</Form.Group>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="warning" onClick={handleClose}>
					{t("soajs:buttons.Cancel")}
				</Button>
				<Button
					variant="success"
					onClick={handleSubmit}
					disabled={!validateForm()}
				>
					{t("soajs:buttons.Add")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}